// extracted by mini-css-extract-plugin
export default {"container":"InviteNewUser_container__Gii-W"};